import React, { useState, useEffect } from "react"
import { Footer } from '@chr/navisphereonline-shared-components';
import { loadAppConfig } from '@chr/online-shared-microsite-core';
import logoModule from '@chr/autoStyle/dist/img/CHR/CHR_LogoTM_Horz_2C_RGB.png';

export interface EmailPreviouslyConfirmedProps{
  confirmedDate: Date;
}

export const EmailPreviouslyConfirmed = (props: EmailPreviouslyConfirmedProps) => {
  const [ onlineOneUrl, setOnlineOneUrl ] = useState('');

  useEffect(() => {
    async function getUrl() {
      const { online1Uri } = await loadAppConfig() as AppConfig;
      setOnlineOneUrl(online1Uri);
    }

    getUrl();
  }, []);

  var date = new Date(props.confirmedDate);

  return (
    <div id="email-previously-confirmed">
    <div className="container main margin-top-50">
      <div>
        <img
          className="chr-logo"
          src={logoModule}
          style={{maxWidth: '200px'}}
          alt="CHR-logo" />
      </div>
      <div className="margin-top-20">
        <h1 style={{color: '#333'}} >Email already confirmed.</h1>
      </div>

      <p data-testid="confirmed-date">
        The email address for your Navisphere account was already confirmed on {formatNumber(date.getMonth() + 1)}/{formatNumber(date.getDate())}/{date.getFullYear()}.
        Thanks for your thoroughness!
      </p>

      <p>
        Contact your C.H. Robinson representitive with any questions.
      </p>

      <div className="margin-top-20">
        <a
          href={onlineOneUrl}
          className="btn btn-primary"
          data-testid="goto-btn"
        >
          Go to navisphere.chrobinson.com
        </a>
      </div>
    </div>
    <Footer />
  </div>
  );
}

function formatNumber(num: number){
  return num.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  });
}

